export default "__VITE_ASSET__xwViZRRS__"